<div class="no-scrollbar flex h-screen w-screen flex-row overflow-auto">
  <main class="flex h-full w-full flex-col items-center p-6 md:w-[28rem] md:p-12">
    <ng-content />
  </main>
  <aside
    class="sticky top-0 hidden w-[calc(100vw-28rem)] items-center justify-center bg-primary-light md:flex"
  >
    <app-typed />
  </aside>
</div>
